import {Capacitor} from '@capacitor/core'

export class Logger {
    private static isDevelopment(): boolean {
        return import.meta.env.MODE !== 'production'
    }

    private static prepareForOutput(...args: any[]): string[] {
        return args.map(arg => {
            if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
                try {
                    return JSON.stringify(arg, null, 2);
                } catch (error) {
                    return String(arg);
                }
            } else {
                return arg;
            }
        });
    }

    private static prepareForOutputAll(...args: any[]): string[] {
        return args.map(arg => {
            try {
                return JSON.stringify(arg, null, 2);
            } catch (error) {
                // Fallback für nicht-serialisierbare Objekte
                return String(arg);
            }
        });
    }

    static log(...args: any[]): void {
        if (this.isDevelopment()) {
            console.log(this.prepareForOutput(...args))
        }
    }

    static info(...args: any[]): void {
        //if (this.isDevelopment()) {
        console.info(this.prepareForOutput(...args))
        //}
    }

    static error(...args: any[]): void {
        //if (this.isDevelopment()) {
        console.error(this.prepareForOutput(...args))
        //}
    }

    static debug(...args: any[]): void {
        if (this.isDevelopment()) {
            console.debug(this.prepareForOutput(...args))
        }
    }

    static warn(...args: any[]): void {
        //if (this.isDevelopment()) {
        console.warn(this.prepareForOutput(...args))
        //}
    }
}
